<template>
  <section class="qrs-typography">
    <pageHeader>
      <h2 class="qrs-header-xl mt--0 mb--0">My wellbeing diary</h2>
    </pageHeader>

    <div class="image__panel mt--16 mb--16">
      <img :src="introImg" />
    </div>

    <div class="accordion govuk-accordion__section">
      <div class="accordion__header js-enabled govuk-accordion__section-header">
        <button type="button" class="govuk-accordion__section-button">
          <h2
            class="accordion__header__title govuk-accordion__section-heading"
            :class="active ? 'accordion--active' : ''"
            @click.prevent="active = !active"
          >
            About my wellbeing diary
            <icon
              class="accordion__header--icon"
              v-show="!active"
              icon="plus"
            />
            <icon
              class="accordion__header--icon"
              :class="active ? 'accordion--active' : ''"
              v-show="active"
              icon="minus"
            />
          </h2>
        </button>
      </div>
      <div
        class="accordion__content govuk-accordion__section-content"
        v-show="active"
      >
        <p>
          This diary helps you to record how you feel over a period of time, and
          to find out about the support available.
        </p>
        <p>
          It asks <strong>5 questions</strong> to help you record how you feel.
          Answer as many questions as you want. You can see how your feelings
          change over time.
        </p>

        <p>
          You can also link to information, activities and support to help you
          to feel better.
        </p>

        <p>
          <strong
            >If you would like help to complete this diary, please ask a carer
            or family member.</strong
          >
        </p>
      </div>
    </div>

    <button
      name="get started"
      aria-label="get started with my symptom diary"
      class="govuk-button mt--24 d-block"
      @click="$parent.goTo($Statements)"
    >
      How do you feel today?
      <span class="screen-reader-text"
        >get started with how you feel today</span
      >
    </button>

    <button
      v-if="this.$parent.viewDiary"
      name="View my wellbeing diary"
      aria-label="View my wellbeing diary"
      class="govuk-button govuk-button--secondary"
      @click="$parent.goTo($MyWellbeingDiary)"
    >
      View my wellbeing diary
      <span class="screen-reader-text">View my wellbeing diary</span>
    </button>
  </section>
</template>

<script>
export default {
  name: "intro",

  data() {
    return {
      active: this.$parent.accordionActive,
      introImg: this.$parent.introImg,
    };
  },
};
</script>